export default __webpack_public_path__ + "static/media/orange-deposit.b9183cee.svg";